const initTopMvSlide = () => {
  const mvSlide = document.querySelector('.js-top-mv-slide');

  if (!mvSlide || typeof Swiper === 'undefined') {
    return;
  }

  if (mvSlide.dataset.swiperInitialized === 'true') {
    return;
  }

  const wrapper = mvSlide.querySelector('.swiper-wrapper');
  const slides = Array.from(mvSlide.querySelectorAll('.swiper-slide'));
  const baseCount = Number(mvSlide.dataset.baseCount || 0);

  if (!wrapper || !slides.length || !baseCount) {
    return;
  }

  const images = mvSlide.querySelectorAll('img');

  const waitForImages = Promise.all(
    Array.from(images).map((image) => {
      if (image.complete) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        image.addEventListener('load', resolve, {once: true});
        image.addEventListener('error', resolve, {once: true});
      });
    }),
  );

  waitForImages.then(() => {
    mvSlide.dataset.swiperInitialized = 'true';

    const swiper = new Swiper(mvSlide, {
      loop: false,
      autoplay: false,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 24,
      allowTouchMove: false,
      simulateTouch: false,
      freeMode: false,
      watchSlidesProgress: false,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      breakpoints: {
        1021: {
          spaceBetween: 48,
        },
      },
    });

    let translateX = 0;
    let baseWidth = 0;
    let animationId = null;
    let lastTime = null;

    const getSpaceBetween = () => {
      const activeSpace = swiper.params.spaceBetween;

      if (typeof activeSpace === 'number') {
        return activeSpace;
      }

      return 0;
    };

    const updateBaseWidth = () => {
      swiper.update();

      const spaceBetween = getSpaceBetween();
      const baseSlides = slides.slice(0, baseCount);

      baseWidth = baseSlides.reduce((total, slide, index) => {
        const slideWidth = slide.getBoundingClientRect().width;
        const space = index === baseSlides.length - 1 ? 0 : spaceBetween;

        return total + slideWidth + space;
      }, 0);
    };

    const startMarquee = () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }

      lastTime = null;

      const tick = (currentTime) => {
        if (lastTime === null) {
          lastTime = currentTime;
        }

        const delta = currentTime - lastTime;
        lastTime = currentTime;

        const speed = window.innerWidth >= 1021 ? 0.08 : 0.06;

        translateX += delta * speed;

        if (baseWidth > 0 && translateX >= baseWidth) {
          translateX -= baseWidth;
        }

        wrapper.style.transitionDuration = '0ms';
        wrapper.style.transitionTimingFunction = 'linear';
        wrapper.style.transform = `translate3d(${-translateX}px, 0, 0)`;

        animationId = requestAnimationFrame(tick);
      };

      animationId = requestAnimationFrame(tick);
    };

    const restartMarquee = () => {
      translateX = 0;
      updateBaseWidth();
      startMarquee();
    };

    restartMarquee();

    window.addEventListener('load', restartMarquee);
    window.addEventListener('resize', restartMarquee);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (animationId) {
          cancelAnimationFrame(animationId);
          animationId = null;
        }

        return;
      }

      restartMarquee();
    });
  });
};

/**
 * 機能紹介の縦スライド
 * 画像読み込み前に%指定のアニメーションを開始するとトラック高が途中で変わり、
 * SP実機でアニメーション速度が不安定になるため、画像のデコード後に開始する。
 */
const initFunctionBlockSlides = () => {
  const tracks = document.querySelectorAll('.top__function-block-slide-track');

  tracks.forEach((track) => {
    const images = Array.from(track.querySelectorAll('img'));
    const waitForImages = images.map((image) => {
      const waitForLoad = image.complete
        ? Promise.resolve()
        : new Promise((resolve) => {
          image.addEventListener('load', resolve, {once: true});
          image.addEventListener('error', resolve, {once: true});
        });

      return waitForLoad.then(() => {
        if (typeof image.decode !== 'function' || !image.naturalWidth) {
          return undefined;
        }

        return image.decode().catch(() => undefined);
      });
    });

    Promise.all(waitForImages).then(() => {
      // 確定後のトラック高で合成レイヤーを作り直してから再生する。
      void track.offsetHeight;
      track.classList.add('is-ready');
    });
  });
};

/**
 * MVモック画像の自動切り替え
 */
const initTopMvMock = () => {
  const mocks = document.querySelectorAll('.js-top-mv-mock');

  if (mocks.length < 2) {
    return;
  }

  const INTERVAL = 3000;
  let currentIndex = 0;

  setInterval(() => {
    mocks[currentIndex].classList.remove('is-active');

    currentIndex = (currentIndex + 1) % mocks.length;

    mocks[currentIndex].classList.add('is-active');
  }, INTERVAL);
};

/**
 * 紹介セクションの画像自動切り替え（ページネーション同期）
 */
const initTopIntroductionSlide = () => {
  const slides = document.querySelectorAll('.js-top-introduction-slide');

  if (!slides.length) {
    return;
  }

  const INTERVAL = 3000;

  slides.forEach((slide) => {
    if (slide.dataset.introductionInitialized === 'true') {
      return;
    }

    const items = Array.from(slide.querySelectorAll('.js-top-introduction-item'));
    const slideContainer = slide.closest('.top__introduction-right-inner');
    const bullets = slideContainer
      ? Array.from(slideContainer.querySelectorAll('.js-top-introduction-bullet'))
      : [];

    if (items.length < 2) {
      return;
    }

    slide.dataset.introductionInitialized = 'true';

    const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
    let currentIndex = activeIndex >= 0 ? activeIndex : 0;

    items.forEach((item, index) => {
      item.classList.toggle('is-active', index === currentIndex);
    });
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle('-current', index === currentIndex);
    });

    setInterval(() => {
      items[currentIndex].classList.remove('is-active');

      if (bullets[currentIndex]) {
        bullets[currentIndex].classList.remove('-current');
      }

      currentIndex = (currentIndex + 1) % items.length;

      items[currentIndex].classList.add('is-active');

      if (bullets[currentIndex]) {
        bullets[currentIndex].classList.add('-current');
      }
    }, INTERVAL);
  });
};

const initTopUsageSwiper = () => {
  const usageSwiper = document.querySelector('.js-top-usage-swiper');

  if (!usageSwiper || typeof Swiper === 'undefined') {
    return;
  }

  if (usageSwiper.dataset.swiperInitialized === 'true') {
    return;
  }

  usageSwiper.dataset.swiperInitialized = 'true';

  const usageSlider = usageSwiper.closest('.top__usage-slider');
  const prevButton = usageSlider ? usageSlider.querySelector('.js-top-usage-prev') : null;
  const nextButton = usageSlider ? usageSlider.querySelector('.js-top-usage-next') : null;

  new Swiper(usageSwiper, {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 600,
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    allowTouchMove: true,
    navigation: {
      prevEl: prevButton,
      nextEl: nextButton,
    },
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initTopMvSlide();
  initFunctionBlockSlides();
  initTopMvMock();
  initTopIntroductionSlide();
  initTopUsageSwiper();
});
